import styled from 'styled-components'
import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { laChannelCount, laDiscountPriceMonthly } from 'src/constants/planData/latinoPlanData'
import { promoCodes } from 'src/constants'

export default (props) => {
  return (
    <StyledContainer>
      <LatinoTemplateDefault
        location={props.location}
        lang="en"
        market="latino"
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-western-union.png"
        poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
        posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
        title="Save big on live TV for your family"
        subtitle={
          <>
            {laChannelCount}+ channels of sports, news, novelas, and{' '}
            <span className="desktop-line-break">
              entertainment in Spanish for only{' '}
              <span className="green-underline">${laDiscountPriceMonthly}</span> for the first two
              months.
            </span>{' '}
          </>
        }
        networkSet={'entertainmentLatino'}
        offerCode={promoCodes.western_union}
        noteLink="/la/western-union-es/"
        cardFootnote="*Offer valid for the first 2 months. Renews at $14.99/mo. Additional taxes and fees may apply. Prices subject to change. Cancel anytime."
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
